<div class="dialog-title">Unit Details</div>

<div class="value-container">
  <div class="content-wrapper full">
    <div class="label-f">Unit No.</div>
    <div class="value-f">A101</div>
  </div>
  <div class="content-wrapper full">
    <div class="label-f">CRM Unit Status</div>
    <div class="value-f">Reserved</div>
  </div>
  <div class="content-wrapper full">
    <div class="label-f">Dotnet/Pplus Unit Status</div>
    <div class="value-f">Reserved</div>
  </div>
</div>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Close</button>
  <button mat-button color="primary" [mat-dialog-close]="false">
    Retrieve Latest Info
  </button>
</div>
